"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ confirm, description }) {
    return confirm({
        description,
        cancellationButtonProps: { style: { display: 'none' } },
    });
}
exports.default = default_1;
